import { ACTION_TYPES, useLicitacoesDispatch, useLicitacoesState } from "./licitacoes-context";
import MunicipalPortalAAppService from "application/platform/municipal-portal-service";
import { ILicitacaoPagedRequest } from "models/request/licitacao-paged-request";
import { downloadFile } from "utils/download-file";

export const useLicitacoesController = () => {
    const licitacoesDispatch = useLicitacoesDispatch();
    const { licitacoesPagedRequest } = useLicitacoesState();

    async function exportLicitacoes(format: string) {
        const file = await MunicipalPortalAAppService.exportLicitacoes(licitacoesPagedRequest, format);
        downloadFile(file);
    }

    async function onInit() {
        let request = { page: 0, pageSize: 10 } as ILicitacaoPagedRequest;

        licitacoesDispatch({ type: ACTION_TYPES.setLicitacoesPagedRequest, payload: request });
        licitacoesDispatch({ type: ACTION_TYPES.setLoading, payload: true });

        await listLicitacoes(request);
        await loadLookups();

        licitacoesDispatch({ type: ACTION_TYPES.setLoading, payload: false });
    }

    async function loadLookups() {
        try {
            const [orgaos, modalidades, fases, situacoes, ultimaAtualizacao] = await Promise.all([
                MunicipalPortalAAppService.listOrgaos(),
                MunicipalPortalAAppService.listModalidadesLicitacao(),
                MunicipalPortalAAppService.listFasesLicitacao(),
                MunicipalPortalAAppService.listSituacoesLicitacao(),
                MunicipalPortalAAppService.getLicitacoesUltimaAtualizacao()
            ]);
            licitacoesDispatch({ type: ACTION_TYPES.setOrgaos, payload: orgaos });
            licitacoesDispatch({ type: ACTION_TYPES.setModalidades, payload: modalidades });
            licitacoesDispatch({ type: ACTION_TYPES.setFases, payload: fases });
            licitacoesDispatch({ type: ACTION_TYPES.setSituacoes, payload: situacoes });
            licitacoesDispatch({ type: ACTION_TYPES.setUltimaAtualizacao, payload: ultimaAtualizacao?.dtaUltimaAtualizacao ?? null });
        } catch (error) {
            console.log(error);
        }
    }

    async function listLicitacoes(request: ILicitacaoPagedRequest, showLoading: boolean = false) {
        try {
            if (showLoading) {
                licitacoesDispatch({ type: ACTION_TYPES.setLoading, payload: true });
            }
            licitacoesDispatch({ type: ACTION_TYPES.setError, payload: null });

            const licitacoes = await MunicipalPortalAAppService.listLicitacoes(request);

            licitacoesDispatch({ type: ACTION_TYPES.setLicitacoes, payload: licitacoes });
        } catch (error) {
            console.log(error);
            licitacoesDispatch({ type: ACTION_TYPES.setError, payload: 'Não foi possível carregar as licitações. Tente novamente mais tarde.' });
        } finally {
            if (showLoading) {
                licitacoesDispatch({ type: ACTION_TYPES.setLoading, payload: false });
            }
        }
    }

    const handleOnChange = (e: any) => {
        let updated = { ...licitacoesPagedRequest };

        if (e.target.name === "text-field-term") {
            updated.term = e.target.value;
            if (!updated.term) {
                (async () => await listLicitacoes({ ...updated, page: 0 }, true))();
            }
        } else if (e.target.name === "select-orgao-id") {
            updated.idOrgao = e.target.value;
        } else if (e.target.name === "select-modalidade-id") {
            updated.idModalidadeLicitacao = e.target.value;
        } else if (e.target.name === "select-fase-id") {
            updated.idFaseLicitacao = e.target.value;
        } else if (e.target.name === "select-situacao-id") {
            updated.idSituacaoLicitacao = e.target.value;
        } else if (e.target.name === "date-field-inicio") {
            updated.dataInicio = e.target.value;
        } else if (e.target.name === "date-field-fim") {
            updated.dataFim = e.target.value;
        } else if (e.target.name === "select-order-direction") {
            updated.orderDirection = e.target.value;
            (async () => await listLicitacoes({ ...updated, page: 0 }, true))();
        }

        licitacoesDispatch({ type: ACTION_TYPES.setLicitacoesPagedRequest, payload: updated });
    };

    const clearFilters = async () => {
        const cleared = { page: 0, pageSize: 10 } as ILicitacaoPagedRequest;
        licitacoesDispatch({ type: ACTION_TYPES.setLicitacoesPagedRequest, payload: cleared });
        await listLicitacoes(cleared, true);
    };

    return { listLicitacoes, handleOnChange, onInit, clearFilters, exportLicitacoes };
}
